import { REDUCER_ACTIONS } from './securityContacts.constants';

const reducer = (state, { payload, type }) => {
  switch (type) {
    case REDUCER_ACTIONS.HANDLE_ERROR:
    case REDUCER_ACTIONS.HANDLE_INPUT_CHANGE:
    case REDUCER_ACTIONS.HANDLE_RESPONSE:
    case REDUCER_ACTIONS.VERIFY_CODE:
      return {
        ...state,
        ...payload
      };
    case REDUCER_ACTIONS.SET_SENDING:
      return {
        ...state,
        sending: payload
      };
    default:
      return state;
  }
};

export default reducer;
